import React from 'react';
import { MenuItemGroupProps } from 'rc-menu';
import { StyledMenuItemGroup } from './styles';

const ItemGroup: React.FC<MenuItemGroupProps> = ({ children, ...rest }) => {
    return <StyledMenuItemGroup {...rest}>{children}</StyledMenuItemGroup>;
};

export default ItemGroup;
